module.exports = __webpack_public_path__ + "img/7.88606ec3.png";